<!-- Roller column -->
<div class="roller-column" [class.align-left]="alignment === 'left'" [class.align-right]="alignment === 'right'"
  [class.align-center]="alignment === 'center'">
  <!-- Selection indicator -->
  <div class="selection-indicator"></div>

  <!-- Custom scroll container -->
  <div class="scroll-container" (scroll)="onScroll()" #scrollContainer>
    <!-- Virtual scroll content with fixed height -->
    <div class="virtual-scroll-content" [style.height.px]="totalScrollHeightPx">
      <!-- Physical items container with transform offset -->
      <div class="items-container" [style.transform]="'translateY(' + physicalItemsOffsetPx + 'px)'">
        @for (i of physicalItemIndices; track i) {
          <div class="roller-item"
            (mousedown)="onItemMouseDown($event)"
            (click)="onItemClick(i, $event)">
            {{ getItemContent(i) }}
          </div>
        }
      </div>
    </div>
  </div>
</div>